export default __webpack_public_path__ + "static/media/chevron-right.00c7fd75.svg";